import { COLUMNS_MASTER_DATA } from "../actions/types";

export default function (state = {}, action) {
  switch (action.type) {
    case COLUMNS_MASTER_DATA:
      return { ...state, columnMasterData: action.payload };
    default:
      return state;
  }
}
